import moment from 'moment';
import { getters } from '@/modules/core/app/helpers/store';
import { RelativeDateRangeKey } from '@/modules/core/daterange/daterange.constants';

export class BaseDateRangeConfig {
  /**
   * @type {Array.<RelativeDateRange>}
   */
  relativeRanges;

  constructor() {
    this.relativeRanges = {};

    // Additional NON-datarangepicker props
    if (getters.daterange && getters.daterange.getRelativeDateRanges) {
      this.relativeRanges = getters?.daterange?.getRelativeDateRanges();
    }
  }

  /**
   * @param key
   * @returns {{start: moment.Moment, end: moment.Moment}}
   */
  getDateRangeFromRelativeRange(key) {
    if (key === RelativeDateRangeKey.DEFAULT) {
      const dateRange = getters.daterange.getDateRange();
      return {
        key,
        start: moment(dateRange.start_date),
        end: moment(dateRange.end_date),
      };
    }

    const relativeRanges = getters.daterange.getRelativeDateRanges() ?? this.relativeRanges ?? {};
    const selectedRange = relativeRanges[key];

    const startDate = selectedRange ? selectedRange.start : '';
    const endDate = selectedRange ? selectedRange.end : '';

    return {
      key,
      start: moment(startDate),
      end: moment(endDate),
    };
  }
}

export default new BaseDateRangeConfig();
